export default "__VITE_ASSET__YhdRslaKBFHUNcbQJsGMSw__"